export default __webpack_public_path__ + "static/media/gorod.38dbedd7.jpg";